/**
 * Stand-in floor plan used when a site system has no background yet.
 *
 * Width, height, and viewBox give the image an intrinsic size. Without them
 * the canvas collapses and equipment cannot be dropped onto it.
 * Decodes to:
 * <svg xmlns="http://www.w3.org/2000/svg" width="1600" height="900" viewBox="0 0 1600 900"></svg>
 */
export const BLANK_BASE_LAYOUT =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjAwIiBoZWlnaHQ9IjkwMCIgdmlld0JveD0iMCAwIDE2MDAgOTAwIj48L3N2Zz4=';

/**
 * SVG the API stores when a twin is created without an uploaded file.
 * It has no width, height, or viewBox, so it cannot drive the canvas.
 */
const UNSIZED_BLANK_BASE_LAYOUT =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjwvc3ZnPg==';

/** Use the sized blank canvas when a twin has no usable background. */
export function withBlankBaseLayout(
  baseLayout: string | null | undefined
): string {
  if (!baseLayout?.trim() || baseLayout === UNSIZED_BLANK_BASE_LAYOUT) {
    return BLANK_BASE_LAYOUT;
  }
  return baseLayout;
}

/** SVG file sent on the first save of a twin that still has the blank canvas. */
export function blankBaseLayoutFile(): File {
  const encoded = BLANK_BASE_LAYOUT.slice(
    'data:image/svg+xml;base64,'.length
  );
  const svg = atob(encoded);
  return new File([svg], 'blank-layout.svg', { type: 'image/svg+xml' });
}
